export default class AgentConfig {
  disabled?: boolean;
  httpsEnabled?: boolean;
  port?: number;
  constructor(obj?: AgentConfig) {
    this.disabled = obj?.disabled ?? false;
    this.httpsEnabled = obj?.httpsEnabled ?? false;
    this.port = obj?.port;
  }
}
